import { Component } from '@angular/core'
import { InlineEditDialogCellDirective } from '../inline-edit-dialog-cell'

@Component({
  selector: 'jml-lib-json-cell',
  templateUrl: './json-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class JsonCellComponent extends InlineEditDialogCellDirective {
  triggerEdit(editorType: string, readOnly: boolean) {
    this.openEditorDialog(editorType, readOnly)
  }
}
